<info-navigation [type]="'invitations'" />
<div *ngIf="data?.length > 0; else placeholder">
  <ng-container *ngFor="let item of data; let i = index">
    <info-group [data]="item" [type]="'invitations'" [index]="i"></info-group>
  </ng-container>
</div>
<ng-template #placeholder>
  <div *ngIf="loading; else notLoading" class="placeholder">
    <p>Loading invitations...</p>
  </div>
  <ng-template #notLoading>
    <div class="placeholder">
      <p>You currently have no invitations.</p>
    </div>
  </ng-template>
</ng-template>
<allbids-submitted-dialog
  [active]="bidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedAllBidsModal()"
  [ngClass]="{ 'documents-dialog--active': bidSubmittedActive }"
/>
<decline-success
  [active]="declineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': declineSuccessActive }"
/>
<accepted-offered-proposal-dialog
  [active]="isOfferAcceptedActive"
  [multiple]="true"
  (modalClosed)="toggleCloseOfferAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isOfferAcceptedActive }"
/>
